export default __webpack_public_path__ + "static/media/panel1.7d845a81.png";